import { createSetThemeBackgroundOutbound, createSetThemeTableOutbound } from '../../api/outbound/pokerOutbounds';
import { DEFAULT_THEME_BACKGROUND_TYPE } from '../../types/themeBackgroundTypes';
import { DEFAULT_THEME_TABLE_TYPE } from '../../types/themeTableTypes';
export const SET_THEME_BACKGROUND = 'SET_THEME_BACKGROUND';
export const SET_THEME_TABLE = 'SET_THEME_TABLE';
function setThemeBackground(themeBackgroundType) {
    return {
        type: SET_THEME_BACKGROUND,
        payload: themeBackgroundType
    };
}
export function thunkSetThemeBackgroundFromUserSettingChange(themeType, themeBackgroundType, socketSend) {
    return function (dispatch) {
        dispatch(setThemeBackground(themeBackgroundType));
        socketSend(createSetThemeBackgroundOutbound(themeType, themeBackgroundType));
    };
}
function setThemeTable(themeTableType) {
    return {
        type: SET_THEME_TABLE,
        payload: themeTableType
    };
}
export function thunkSetThemeTableFromUserSettingChange(themeType, themeTableType, socketSend) {
    return function (dispatch) {
        dispatch(setThemeTable(themeTableType));
        socketSend(createSetThemeTableOutbound(themeType, themeTableType));
    };
}
export function thunkSetThemeFromInbound(inbound, isPowerPlayer) {
    return function (dispatch) {
        dispatch(setThemeBackground(isPowerPlayer ? inbound.themeSet.default.themeBackgroundType : DEFAULT_THEME_BACKGROUND_TYPE));
        dispatch(setThemeTable(isPowerPlayer ? inbound.themeSet.default.themeTableType : DEFAULT_THEME_TABLE_TYPE));
    };
}
